var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from '@material-ui/core';
import { AnimatedComplexSpriteReact } from '@timeflies/animated-complex-sprite';
import { useAssetSpritesheet } from '@timeflies/assets-loader';
import React from 'react';
import { Stage } from 'react-pixi-fiber';
var useStyles = makeStyles(function () { return ({
    root: {
        pointerEvents: 'none'
    }
}); });
export var CharacterAnimatedImage = function (_a) {
    var size = _a.size, scale = _a.scale, fallback = _a.fallback, spriteProps = __rest(_a, ["size", "scale", "fallback"]);
    var classes = useStyles();
    var asset = useAssetSpritesheet('entities');
    if (!asset) {
        return React.createElement(React.Fragment, null, fallback);
    }
    return React.createElement(Stage, { className: classes.root, options: {
            width: size,
            height: size,
            backgroundAlpha: 0,
        } },
        React.createElement(AnimatedComplexSpriteReact, __assign({ spritesheet: asset.spritesheet }, spriteProps, { scale: scale, anchor: 0.5, position: size / 2 })));
};
